const parseAsFloat = (str) => {
    const [sign, numberStr] = str.startsWith('-') ? [-1, str.slice(1)] : [1, str];
    const [integerPart, decimalPart] = numberStr.replace(/^0+/, '0').split('-');
    return sign * (decimalPart === undefined
        ? parseInt(integerPart, 10)
        : parseFloat(`${integerPart}.${decimalPart}`));
};
/*
  map PDS "enriched" selection IDs to format expected by betslip
  There can be three variants currently:
  1. static in-play (football) or pre-match (US sports) market - PDS has the same selection id (UUID) that is in GTP
  e.g. e6884c58-c01e-425e-838d-762fd4c99f56, format = {UUID}
  2. in-play or pre-match handicap (moving line) markets - PDS has selection id enriched with the handicap value added as a suffix
  after an underscore, point (.) is changed to a dash
  e.g. e6884c58-c01e-425e-838d-762fd4c99f56_3-50 (meaning e6884c58-c01e-425e-838d-762fd4c99f56 with line 3.5)
  e6884c58-c01e-425e-838d-762fd4c99f56_-3-50 (meaning e6884c58-c01e-425e-838d-762fd4c99f56 with line -3.5)
  format = {UUID}_{line}
  3. After single market changes trading can have pre-match and in-play in the same market (PM_AND_IP), because Openbet doesn't
  support that it gets split into two markets on outbound e6884c58-c01e-425e-838d-762fd4c99f56 (in-play) and
  e6884c58-c01e-425e-838d-762fd4c99f56_PM (pre-match). The _PM suffix is then an integral part of the selection ID in Openbet
  Those markets can be static or with a handicap as well. Modal needs to be able to handle both PM/IP and static/handicap
  e.g. e6884c58-c01e-425e-838d-762fd4c99f56 (in-play part)
  e6884c58-c01e-425e-838d-762fd4c99f56_PM (pre-match part)
  e6884c58-c01e-425e-838d-762fd4c99f56_3-50 (in-play part with line 3.5)
  e6884c58-c01e-425e-838d-762fd4c99f56_PM_3-50 (pre-match part with line 3.5)
  e6884c58-c01e-425e-838d-762fd4c99f56_PM_-3-50 (pre-match part with line -3.5)
 */
export const mapSelection = (selection) => {
    const split = selection.id.split('_');
    const preMatch = split.find(el => el === 'PM');
    if (preMatch) {
        return {
            selectionId: `${split[0]}_PM`,
            handicap: split[2] ? parseAsFloat(split[2]) : null,
        };
    }
    return {
        selectionId: `${split[0]}`,
        handicap: split[1] ? parseAsFloat(split[1]) : null,
    };
};
